import dataConfigs from '@/project/data'

export const endpoints = {
  ...dataConfigs.endpoints,
}
